module.exports = __webpack_public_path__ + "static/media/image5.cd9429b3.jpeg";